
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 53 53","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M13.88 2.96H3.59V12h9.04V9.58h2.5v4.92H1.09V.46h12.79zM15.13 44.37h-2.5v-3.36H3.59v9.03h10.29v2.5H1.09V38.51h14.04z"}}),_c('path',{staticClass:"icon-fill arrow",attrs:{"fill":"#5ebca8","d":"M12.86 3.66l1.76 1.77-5.39 5.39-3.94-3.94 1.77-1.77 2.17 2.18z"}}),_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M13.88 21.98H3.59v9.04h9.04V28.6h2.5v4.92H1.09V19.48h12.79z"}}),_c('path',{staticClass:"icon-fill arrow",attrs:{"fill":"#5ebca8","d":"M12.86 22.69l1.76 1.77-5.39 5.38-3.94-3.94 1.77-1.77 2.17 2.18z"}}),_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M16.34 48.46l2.39-11.38L44.27 1.71l7.64 5.51-25.54 35.4zm4.75-10.31l-1.14 5.31 4.71-2.75L48.42 7.79 44.83 5.2z"}}),_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M19.165 38.639l1.462-2.028 5.613 4.048-1.463 2.028zM39.338 10.689l1.463-2.028 5.612 4.048-1.462 2.028z"}})])
          )
        }
      }
    